import {IconProps} from './types';

const Chevron = ({fill, className}: IconProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="7"
        height="8"
        fill={'none'}
        viewBox="0 0 7 8"
        className={className}
    >
        <path
            stroke={fill}
            strokeLinecap="round"
            strokeWidth="1.5"
            d="M6 1 2 4l4 3"
        />
    </svg>
);

export default Chevron;
